// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/shinri/AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ShogiPlayer.ShortcutModal .simple_title{border-bottom:1px solid #dbdbdb}.ShogiPlayer.ShortcutModal .table td,.ShogiPlayer.ShortcutModal .table th{vertical-align:middle}.ShogiPlayer.ShortcutModal .table th{font-weight:400;text-align:right;border-width:0;font-size:.75rem}.ShogiPlayer.ShortcutModal .table td{text-align:left;border-width:0}.ShogiPlayer.ShortcutModal .tag{font-weight:700}", ""]);
// Exports
module.exports = exports;
